import { render, staticRenderFns } from "./ConfettiCanon.vue?vue&type=template&id=5a777a49&"
import script from "./ConfettiCanon.vue?vue&type=script&lang=ts&"
export * from "./ConfettiCanon.vue?vue&type=script&lang=ts&"
import style0 from "./ConfettiCanon.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports